export const reservationDrawer = {
  title: "Detalle de la reserva",
  openFullPage: "Abrir en página completa",
  close: "Cerrar",
};
